import { fromISO } from '@jooxter/utils';

export const getCheckout = ({ checkout }: { checkout: { at: string } }) => fromISO(checkout.at);
